import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints';
import { appendQuery } from '../../shared/utils/commenFunctions';
import {
  AdminLocationCreateRequest,
  AdminLocationDetailResponse,
  AdminLocationListParams,
  AdminLocationListResponse,
  AdminLocationUpdateRequest,
} from '../models/location-admin.model';

@Injectable({
  providedIn: 'root',
})
export class LocationAdminService {
  private readonly apiService = inject(ApiService);

  listLocations(params: AdminLocationListParams): Observable<AdminLocationListResponse> {
    const queryPayload: Record<string, unknown> = {
      index: params.index,
      limit: params.limit,
      searchText: params.searchText ?? '',
    };

    if (params.isActive !== null && params.isActive !== undefined) {
      queryPayload['isActive'] = params.isActive;
    }

    const url = appendQuery(API_ENDPOINTS.ADMIN.LOCATIONS.LIST, queryPayload);
    return this.apiService.get<AdminLocationListResponse>(url);
  }

  getLocation(locationId: string): Observable<AdminLocationDetailResponse> {
    return this.apiService.get<AdminLocationDetailResponse>(API_ENDPOINTS.ADMIN.LOCATIONS.DETAIL(locationId));
  }

  createLocation(request: AdminLocationCreateRequest): Observable<AdminLocationDetailResponse> {
    return this.apiService.post<AdminLocationDetailResponse>(API_ENDPOINTS.ADMIN.LOCATIONS.CREATE, request);
  }

  updateLocation(locationId: string, request: AdminLocationUpdateRequest): Observable<AdminLocationDetailResponse> {
    return this.apiService.put<AdminLocationDetailResponse>(API_ENDPOINTS.ADMIN.LOCATIONS.UPDATE(locationId), request);
  }
}

